import { React, useState } from 'react'
import LetterCardMatrix from './LetterCardMatrix.js';
import '../../styles.css';

function LetterCardGridSuper(props) {
    const [windowClass, setWindowClass] = useState('individualProgressWindow')

    function classChange() {
        if (windowClass === 'individualProgressWindow') {
            setWindowClass('individualProgressWindowShown')
        } else if (windowClass === 'individualProgressWindowShown') {
            setWindowClass('individualProgressWindow')
        }
    }

    return (
        <div className='column' style={{ marginBottom: 30 }}><button style={{ fontSize: 18 }} className='individualProgressButton' onClick={() => classChange()}>{props.name}</button><div className={windowClass}><LetterCardMatrix username={props.username} name={props.name} /></div></div>
    )
}

export default LetterCardGridSuper
